import { socketService } from '@aqx-core/common/socket';

import { IMetaTraderMessage } from '../topics/metatrader';

class MetaTraderTopicSubscription {
  public subscribe = (tradeSubscription: string, receiver: (payload: IMetaTraderMessage | undefined) => void) => {
    socketService.topics().metatrader.subscribe({
      tradeSubscription,
      receiver
    });
  };

  public unsubscribe = (tradeSubscription: string, receiver: (payload: IMetaTraderMessage | undefined) => void) => {
    socketService.topics().metatrader.unsubscribe({
      tradeSubscription,
      receiver
    });
  };
}

export const metaTraderTopicSubscription = new MetaTraderTopicSubscription();
